


import { Routes, Route } from 'react-router-dom';
import { variables } from './Component/Variables';

import { useEffect } from "react"




// Arabic Part





import Football_Ar from "./Component/Football_Ar"

import Most_View_Ar from "./Component/Most_View_Ar"

import Basketball_Ar from "./Component/Basketball_Ar"

import Cricket_Ar from "./Component/Cricket_Ar"


import Racing_Ar from "./Component/Racing_Ar"
import Tennis_Ar from "./Component/Tennis_Ar"

import Boxing_Ar from "./Component/Boxing_Ar"

import UFC_Ar from "./Component/UFC_Ar"


import TrendingNews_Ar from "./Component/TrendingNews_Ar"
import TrendingNews_Main_Ar from "./Component/TrendingNews_Main_Ar"

import FeatureNews_Home_Ar from "./Component/FeatureNews_Home_Ar"


import Cricket_Home_Ar from "./Component/Cricket_Home_Ar"


import Football_MostView_Ar from "./Component/Football_MostView_Ar"

import Tennis_Main_Ar from "./Component/Tennis_Main_Ar"
import Tennis_Home_Ar from "./Component/Tennis_Home_Ar"

import WhatNew_Home_Ar from "./Component/WhatNew_Home_Ar"

import UFC_HOME_ar from "./Component/UFC_HOME_ar"

import Boxing_Home_Ar from "./Component/Boxing_Home_Ar"

import Arabic from "./Component/Arabic"

import News_Page_Ar from "./Component/News_Page_Ar"

import OurLatest_News_Ar from "./Component/OurLatest_News_Ar"

export default function App() {

  return (


    <div className="App">



      <Routes>



        <Route path={variables.basename + "/Football_Ar"} element={<Football_Ar />} />
        <Route path="http://athletixnet.com/arabic/Football_Ar" element={<Football_Ar />} />
        <Route path={"/arabic/Football_Ar"} element={<Football_Ar />} />









        <Route path={variables.basename + "/Most_View_Ar"} element={<Most_View_Ar />} />
        <Route path="http://athletixnet.com/arabic/Most_View_Ar" element={<Most_View_Ar />} />
        <Route path={"/arabic/Most_View_Ar"} element={<Most_View_Ar />} />

        <Route path={variables.basename + "/Basketball_Ar"} element={<Basketball_Ar />} />
        <Route path="http://athletixnet.com/arabic/Basketball_Ar" element={<Basketball_Ar />} />
        <Route path={"/arabic/Basketball_Ar"} element={<Basketball_Ar />} />


        <Route path={variables.basename + "/Cricket_Ar"} element={<Cricket_Ar />} />
        <Route path="http://athletixnet.com/arabic/Cricket_Ar" element={<Cricket_Ar />} />
        <Route path={"/arabic/Cricket_Ar"} element={<Cricket_Ar />} />



        <Route path={variables.basename + "/Racing_Ar"} element={<Racing_Ar />} />
        <Route path="http://athletixnet.com/arabic/Racing_Ar" element={<Racing_Ar />} />
        <Route path={"/arabic/Racing_Ar"} element={<Racing_Ar />} />



        <Route path={variables.basename + "/Tennis_Ar"} element={<Tennis_Ar />} />
        <Route path="http://athletixnet.com/arabic/Tennis_Ar" element={<Tennis_Ar />} />
        <Route path={"/arabic/Tennis_Ar"} element={<Tennis_Ar />} />



        <Route path={variables.basename + "/Boxing_Ar"} element={<Boxing_Ar />} />
        <Route path="http://athletixnet.com/arabic/Boxing_Ar" element={<Boxing_Ar />} />
        <Route path={"/arabic/Boxing_Ar"} element={<Boxing_Ar />} />



        <Route path={variables.basename + "/UFC_Ar"} element={<UFC_Ar />} />
        <Route path="http://athletixnet.com/arabic/UFC_Ar" element={<UFC_Ar />} />
        <Route path={"/arabic/UFC_Ar"} element={<UFC_Ar />} />


        <Route path={variables.basename + "/TrendingNews_Ar"} element={<TrendingNews_Ar />} />
        <Route path="http://athletixnet.com/arabic/TrendingNews_Ar" element={<TrendingNews_Ar />} />
        <Route path={"/arabic/TrendingNews_Ar"} element={<TrendingNews_Ar />} />


        <Route path={variables.basename + "/TrendingNews_Main_Ar"} element={<TrendingNews_Main_Ar />} />
        <Route path="http://athletixnet.com/arabic/TrendingNews_Main_Ar" element={<TrendingNews_Main_Ar />} />
        <Route path={"/arabic/TrendingNews_Main_Ar"} element={<TrendingNews_Main_Ar />} />


        <Route path={variables.basename + "/FeatureNews_Home_Ar"} element={<FeatureNews_Home_Ar />} />
        <Route path="http://athletixnet.com/arabic/FeatureNews_Home_Ar" element={<FeatureNews_Home_Ar />} />
        <Route path={"/arabic/FeatureNews_Home_Ar"} element={<FeatureNews_Home_Ar />} />


        <Route path={variables.basename + "/Cricket_Home_Ar"} element={<Cricket_Home_Ar />} />
        <Route path="http://athletixnet.com/arabic/Cricket_Home_Ar" element={<Cricket_Home_Ar />} />
        <Route path={"/arabic/Cricket_Home_Ar"} element={<Cricket_Home_Ar />} />


        <Route path={variables.basename + "/Football_MostView_Ar"} element={<Football_MostView_Ar />} />
        <Route path="http://athletixnet.com/arabic/Football_MostView_Ar" element={<Football_MostView_Ar />} />
        <Route path={"/arabic/Football_MostView_Ar"} element={<Football_MostView_Ar />} />


        <Route path={variables.basename + "/Tennis_Main_Ar"} element={<Tennis_Main_Ar />} />
        <Route path="http://athletixnet.com/arabic/Tennis_Main_Ar" element={<Tennis_Main_Ar />} />
        <Route path={"/arabic/Tennis_Main_Ar"} element={<Tennis_Main_Ar />} />



        <Route path={variables.basename + "/Tennis_Home_Ar"} element={<Tennis_Home_Ar />} />
        <Route path="http://athletixnet.com/arabic/Tennis_Home_Ar" element={<Tennis_Home_Ar />} />
        <Route path={"/arabic/Tennis_Home_Ar"} element={<Tennis_Home_Ar />} />



        <Route path={variables.basename + "/WhatNew_Home_Ar"} element={<WhatNew_Home_Ar />} />
        <Route path="http://athletixnet.com/arabic/WhatNew_Home_Ar" element={<WhatNew_Home_Ar />} />
        <Route path={"/arabic/WhatNew_Home_Ar"} element={<WhatNew_Home_Ar />} />


        <Route path={variables.basename + "/UFC_HOME_ar"} element={<UFC_HOME_ar />} />
        <Route path="http://athletixnet.com/arabic/UFC_HOME_ar" element={<UFC_HOME_ar />} />
        <Route path={"/arabic/UFC_HOME_ar"} element={<UFC_HOME_ar />} />


        <Route path={variables.basename + "/Boxing_Home_Ar"} element={<Boxing_Home_Ar />} />
        <Route path="http://athletixnet.com/arabic/Boxing_Home_Ar" element={<Boxing_Home_Ar />} />
        <Route path={"/arabic/Boxing_Home_Ar"} element={<Boxing_Home_Ar />} />


        <Route path={variables.basename + "/Arabic"} element={<Arabic />} />
        <Route path="http://athletixnet.com/arabic/Arabic" element={<Arabic />} />
        <Route path={"/arabic/Arabic"} element={<Arabic />} />




        <Route path={"/arabic/:storyID/:title"} element={<News_Page_Ar />} />
        <Route path={variables.basename + "/arabic/:storyID/:title"} element={<News_Page_Ar />} />
        <Route path={variables.basename + "/news_page/:storyID/:title"} element={<News_Page_Ar />} />
        <Route path={"/arabic/:storyID/:title"} element={<News_Page_Ar />} />






        <Route path={variables.basename + "/OurLatest_News_Ar"} element={<OurLatest_News_Ar />} />
        <Route path="http://athletixnet.com/arabic/OurLatest_News_Ar" element={<OurLatest_News_Ar />} />
        <Route path={"/arabic/OurLatest_News_Ar"} element={<OurLatest_News_Ar />} />

      </Routes>
    </div>



  );
}
